import { SagaMiddleware } from "redux-saga";
import saga from "./sagas";

export default function configureApi(sagaMiddleware: SagaMiddleware) {
  sagaMiddleware.run(saga);
}
